import posthog from 'posthog-js';

function isPostHogReady() {
  return !!process.env.NEXT_PUBLIC_POSTHOG_KEY;
}

export function identifyUser(user: { id: string; email?: string | null }) {
  if (!isPostHogReady()) return;
  posthog.identify(user.id, user.email ? { email: user.email } : {});
}

export function resetUser() {
  if (!isPostHogReady()) return;
  posthog.reset();
}

export function trackSignup(properties?: Record<string, any>) {
  if (!isPostHogReady()) return;
  posthog.capture('user_signed_up', properties);
}

export function trackLogin(properties?: Record<string, any>) {
  if (!isPostHogReady()) return;
  posthog.capture('user_logged_in', properties);
}
